import { render, staticRenderFns } from "./dialogReviewPlatformAdd.vue?vue&type=template&id=48507efa"
import script from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js"
export * from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js"
import style0 from "./dialogReviewPlatformAdd.vue?vue&type=style&index=0&id=48507efa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports